import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

const useResizeObserver = ref => {
  const [dimensions, setDimensions] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    if (ref.current) {
      observer.current = new ResizeObserver(entries => {
        const { width, height } = entries[0].contentRect;
        setDimensions({ width, height });
      });
      observer.current.observe(ref.current);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [ref]);

  return dimensions;
};

export default useResizeObserver;
